<template>
  <div>
    <documents-add-edit-modal
      v-if="showDocumentsModal"
      v-model="showDocumentsModal"
      :sidebarItems="sidebarItems"
      :selectedSidebarItemIndex="selectedSidebarItemIndex"
      :sidebarTitle="formGroup ? formGroup.name : ''"
      :modalTitle="modalTitle"
      :modalSubtitle="modalSubtitle"
      :reloadSelectedDocument="reloadSelectedDocument"
      @onModify="onModify"
      @setCurrentFormItem="setCurrentFormItem"
      :isFormGroup="true"
    />
  </div>
</template>

<script>
import DocumentsAddEditModal from "../../document_archive/DocumentsAddEditModal";
import eocServer from "../../../server/eoc";
import { mapGetters, mapMutations } from "vuex";

const getFormSubmit = (results, formId) => {
  for (let index = 0; index < results.length; index++) {
    const result = results[index];
    if (result.formId == formId) return result;
  }
  return null;
};

export default {
  name: "DocumentGroupAddEditModal",
  components: { DocumentsAddEditModal },
  props: ["formGroupId", "clientId", "eocId", "submitId", "initialFormId"],
  data() {
    return {
      sidebarItems: null,
      selectedSidebarItemIndex: 0,
      totalItems: 0,
      showDocumentsModal: false,
      eoc: null,
      form: null,
      reloadSelectedDocument: +new Date(),
      formGroup: null,
      document: null,
      forms: []
    };
  },
  async mounted() {
    const sidebarItems = [];
    this.formGroup = await this.getFormGroupById(this.formGroupId);
    if (this.submitId) {
      this.submit = await this.getFormGroupSubmitById(this.submitId);
      this.forms = this.submit.forms;
    } else {
      this.forms = this.formGroup.forms;
    }

    await this.initializeFormGroupSubmit({
      submitId: this.submitId,
      formGroupId: this.formGroup.id,
      clientId: this.clientId,
      results: this.submit ? this.submit.results : null,
      formIds: this.formGroup.formIds,
      eocId: this.eocId
    });

    this.eoc = await eocServer.get(this.eocId);

    for (let index = 0; index < this.forms.length; index++) {
      const form = this.forms[index];

      if (this.hasCurrentUserDocumentPermission(form.id, "hasEntryAccess")) {
        let result = this.submit
          ? getFormSubmit(this.submit.results, form.id)
          : null;
        sidebarItems.push({
          formId: form.id,
          documentId: result ? result.documentId : null,
          clientId: this.clientId,
          eocId: this.eocId,
          name: form.name,
          tooltip: form.name,
          patientData: this.eoc.patient,
          documentGroupId: this.submitId,
          documentStatus: result ? result.status : "",
          effectiveDateTime: result ? result.effectiveDate : null
        });
      }

      if (this.initialFormId == form.id) {
        this.selectedSidebarItemIndex = index;
      }
    }

    this.document = sidebarItems[this.selectedSidebarItemIndex]?.documentId
      ? await this.getFormSubmitById(
          sidebarItems[this.selectedSidebarItemIndex].documentId
        )
      : null;

    this.sidebarItems = sidebarItems;
    this.totalItems = this.sidebarItems.length;
    this.showDocumentsModal = true;
  },
  methods: {
    ...mapMutations("formGroupSubmitter", ["initializeFormGroupSubmit"]),
    onModify(params) {
      this.$emit("onModify", params);
    },
    async setCurrentFormItem(params) {
      if (params.prevDocumentStatus != "") {
        this.sidebarItems[this.selectedSidebarItemIndex].documentStatus =
          params.prevDocumentStatus;
      }
      if (params.prevDocumentId != null) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentId =
          params.prevDocumentId;
      }

      if (params.totalSignatures != "") {
        this.sidebarItems[this.selectedSidebarItemIndex].totalSignature =
          params.totalSignatures;
      }

      if (params.documentRefNumber) {
        this.sidebarItems[this.selectedSidebarItemIndex].documentRefNumber =
          params.documentRefNumber;
      }
      this.selectedSidebarItemIndex =
        params.sidebarItemIndex >= this.sidebarItems.length
          ? 0
          : params.sidebarItemIndex;
      if (params.prevDocumentGroupId) {
        this.sidebarItems = this.sidebarItems.map(sidebarItem => ({
          ...sidebarItem,
          documentGroupId: params.prevDocumentGroupId
        }));
      }

      const item = this.sidebarItems[this.selectedSidebarItemIndex];
      this.document = item.documentId
        ? await this.getFormSubmitById(item.documentId)
        : null;

      this.reloadSelectedDocument = +new Date();
    }
  },
  computed: {
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    ...mapGetters("formSubmitter", ["getFormSubmitById"]),
    ...mapGetters("formGroup", ["getFormGroupById"]),
    ...mapGetters("formGroupSubmitter", ["getFormGroupSubmitById"]),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    modalTitle() {
      let pos = 0;
      if (this.selectedSidebarItemIndex == this.sidebarItems.length) {
        pos = this.sidebarItems.length - 1;
      } else {
        pos = this.selectedSidebarItemIndex;
      }
      if (this.sidebarItems[pos].name != this.forms[pos].name) {
        let found = false;
        for (var i = 0; i < this.forms.length && !found; i++) {
          if (this.forms[i].name == this.sidebarItems[pos].name) {
            pos = i;
            found = true;
          }
        }
      }
      if (this.formGroup) {
        return this.forms[pos].name;
      }
      return "";
    },
    modalSubtitle() {
      let title = "";
      if (this.eoc) {
        title = `${
          this.document?.documentRefNumber
            ? "Ref# " + this.document.documentRefNumber + " | "
            : ""
        }${this.formatEocObj(this.eoc)}`;
      }
      return title;
    }
  }
};
</script>
